import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import IApplicationDetails from '@sunbit-dev/common/models/cardApply/IApplicationDetails';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions } from '../actions/identificationActions';
import { ActionTypes } from '../models/actions/identification';

export interface IApplicationDetailsState extends Partial<IApplicationDetails> {
  type?: ActionTypes;
  status?: ActionStatus;
  error?: IApplicationError;
}

const initialState: IApplicationDetailsState = {};

export default function applicationDetailsReducer(state = initialState, action: Actions): IApplicationDetailsState {
  switch (action.type) {
    case ActionTypes.getApplicationDetails:
      return { ...state, ...action };
    default:
      return state;
  }
}
